module.exports = __webpack_public_path__ + "img/5.2202db2a.svg";